// Admin utilities and capability hooks.

import { useHasCapability } from 'util/admin';
import { useModuleGlobal } from 'util/datastore';
import { defineModuleGlobal } from 'util/moduledata';
import { t } from 'util/stdtypes';

import { Banner } from './banner';
import { ConversationScreen } from './screen';
import { UtilityText } from './text';

export function RestrictedScreen({ capability, pad, children }) {
    const hasCapability = useHasCapability(capability);
    if (hasCapability === null) {
        return null;
    }
    if (!hasCapability) {
        return (
            <Banner>
                <UtilityText label={t('You do not have access to this feature')} />
            </Banner>
        );
    }
    return <ConversationScreen pad={pad}>{children}</ConversationScreen>;
}

export type LegalDocLinks = {
    communityGuidelines?: string;
    privacyNotice?: string;
    termsOfService?: string;
};

const moduleGlobalSiloName = defineModuleGlobal<string>('PUBLIC', 'admin', 'siloName');
const moduleGlobalShowCollaborationNote = defineModuleGlobal<boolean>('PUBLIC', 'admin', 'showCollaborationNote');
const moduleGlobalLegalDocLinks = defineModuleGlobal<LegalDocLinks>('PUBLIC', 'admin', 'legalDocLinks');

export function useSiloName() {
    return useModuleGlobal(moduleGlobalSiloName);
}

export function useShowCollaborationNote() {
    return useModuleGlobal(moduleGlobalShowCollaborationNote);
}

export function useLegalDocLinks() {
    return useModuleGlobal(moduleGlobalLegalDocLinks);
}

// HACK (Rob): This should be part of admin, not an 'isBeta' module.
// eslint-disable-next-line module-data-owner -- FIXME: use module name 'admin'
const moduleGlobalIsBeta = defineModuleGlobal<boolean>('PUBLIC', 'isBeta', null);

export function useIsBeta() {
    return useModuleGlobal(moduleGlobalIsBeta);
}

// eslint-disable-next-line module-data-owner -- FIXME: use module name 'admin'
